<template>
  <mouse-event-container>
    <div data-component="contentStack">
      <div v-for="(piece, i) in data.stack" class="stack-item" :key="i">
        <component :is="`component_${piece.type}`" :key="piece.type" :data="piece" />
      </div>
    </div>
  </mouse-event-container>
</template>

<script>
// Components
import MouseEventContainer from '@/components/MouseEventContainer';

export default {

  name: 'component_contentStack',

  components: { MouseEventContainer },

  props: ['data'],

};
</script>

<style lang="scss">
[data-component="contentStack"] {
  display: flex;
  flex-direction: column;
}
</style>




// WEBPACK FOOTER //
// src/components/contentStack.vue